import { render, staticRenderFns } from "./SNFeedback.vue?vue&type=template&id=e217d1c0&scoped=true"
import script from "./SNFeedback.vue?vue&type=script&lang=js"
export * from "./SNFeedback.vue?vue&type=script&lang=js"
import style0 from "./SNFeedback.vue?vue&type=style&index=0&id=e217d1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e217d1c0",
  null
  
)

export default component.exports